(function () {
  function freezeTrack(area) {
    const track = area.querySelector(".product__media-gallery .hooper-track");
    if (track) {
      track.style.transform = "none";
      track.style.transition = "none";
      // re-enable transitions for any internal needs
      requestAnimationFrame(() => (track.style.transition = ""));
    }
    const list = area.querySelector(".product__media-gallery .hooper-list");
    if (list) list.style.width = "100%";
  }

  function makeSingle(container) {
    const area = container.querySelector(
      ".product__media-gallery .oke-reviewCarousel-reviews"
    );
    if (!area) return;

    // Keep only the first slide
    const slides = area.querySelectorAll(
      ".product__media-gallery .hooper-slide"
    );
    slides.forEach((s, i) => {
      if (i > 0) s.remove();
    });

    // Kill nav UI just in case
    container
      .querySelectorAll(
        ".product__media-gallery .oke-prevNextButton, .product__media-gallery .oke-reviewCarousel-prev, .product__media-gallery .oke-reviewCarousel-next, .product__media-gallery .oke-dots"
      )
      .forEach((el) => el.remove());

    freezeTrack(area);
    lockHorizontal(area);
  }

  // Block horizontal swipes (so Hooper never moves), but allow vertical page scroll
  function lockHorizontal(area) {
    if (area.dataset.e420Lock) return;
    area.dataset.e420Lock = "1";
    area.style.touchAction = "pan-y"; // keep vertical scroll

    let sx = 0,
      sy = 0;

    area.addEventListener(
      "touchstart",
      (e) => {
        const t = e.touches[0];
        sx = t.clientX;
        sy = t.clientY;
      },
      { passive: true }
    );

    area.addEventListener(
      "touchmove",
      (e) => {
        const t = e.touches[0];
        const dx = t.clientX - sx;
        const dy = t.clientY - sy;

        // Vertical: allow page to scroll
        if (Math.abs(dy) > Math.abs(dx)) return;

        // Horizontal: forward to parent gallery once, then freeze Okendo track
        if (Math.abs(dx) > 8) {
          e.preventDefault();

          const slideLI = area.closest(".e420-review-slide");
          const slider = slideLI?.closest("slider-component");
          const btn = slider?.querySelector(
            dx < 0
              ? ".product__media-gallery .slider-button--next"
              : ".product__media-gallery .slider-button--prev"
          );
          btn?.click();

          freezeTrack(area);
          // small guard to avoid multi-click
          sx = t.clientX;
          sy = t.clientY;
        }
      },
      { passive: false }
    );

    // Any end/transition → snap back to 0
    ["touchend", "pointerup", "transitionend", "mouseleave"].forEach((evt) => {
      area.addEventListener(evt, () => freezeTrack(area), { passive: true });
    });
  }

  function arm(container) {
    if (!container || container.dataset.e420One) return;
    container.dataset.e420One = "1";

    const mo = new MutationObserver(() => makeSingle(container));
    mo.observe(container, { childList: true, subtree: true });

    // Fast path if already rendered
    makeSingle(container);
  }

  // Mount for big slide + thumb
  document
    .querySelectorAll(
      ".product__media-gallery .e420-gallery-oke-container, .product__media-gallery .e420-thumb-oke"
    )
    .forEach(arm);

  // Re-apply after section reloads / variant changes
  const pageObs = new MutationObserver((muts) => {
    muts.forEach((m) =>
      m.addedNodes.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (
          n.matches?.(
            ".product__media-gallery .e420-gallery-oke-container, .product__media-gallery .e420-thumb-oke"
          )
        )
          arm(n);
        n.querySelectorAll?.(
          ".product__media-gallery .e420-gallery-oke-container, .product__media-gallery .e420-thumb-oke"
        ).forEach(arm);
      })
    );
  });
  pageObs.observe(document.documentElement, { childList: true, subtree: true });
})();
